import React, { Fragment } from 'react'
import { formatNumberShort } from '../../utils/formatNumberShort'


const TopBarValues = ({
    commissionedCount,
    pmmCommission,
    portalCommission,
    totalOrders
}) => {




    return (
        <Fragment>
            <div className="flex justify-center gap-[1.5vmax] lg:gap-[2vmax] mb-[2vmax] flex-wrap">
                {/* Card 1 */}
                <div className="w-[48%] lg:w-[31%] flex bg-white dark:bg-slate-950/70 p-[1.5vmax] shadow-sm hover:shadow-md transition-shadow duration-300 rounded-2xl border border-zinc-100 dark:border-indigo-400/20 dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)]">
                    <div className="w-[70%] flex justify-between flex-col gap-[0.5vmax]">
                        <span className="text-[2.5vmax] lg:text-[2vmax] font-jakarta font-bold text-zinc-800 dark:text-white" >
                            {commissionedCount || 0}
                        </span>
                        <span className="text-zinc-500 dark:text-slate-400 uppercase text-[1vmax] lg:text-[0.8vmax] font-semibold tracking-wider" >
                            Commission Pending
                        </span>
                    </div>
                    <div className="w-[30%] flex justify-end items-center">
                        <div className="w-[3.5vmax] h-[3.5vmax] bg-indigo-50 dark:bg-indigo-500/15 rounded-2xl grid place-items-center text-indigo-600 dark:text-indigo-300 text-[1.8vmax] ring-1 ring-indigo-100 dark:ring-indigo-400/20">
                            <i className="fa-solid fa-file-invoice-dollar"></i>
                        </div>
                    </div>
                </div>

                {/* Card 2 */}
                <div className="w-[48%] lg:w-[31%] flex bg-white dark:bg-slate-950/70 p-[1.5vmax] shadow-sm hover:shadow-md transition-shadow duration-300 rounded-2xl border border-zinc-100 dark:border-rose-400/20 dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)] justify-between">
                    <div className="w-[70%] flex justify-between flex-col gap-[0.5vmax]">
                        <span className="text-[2.5vmax] lg:text-[2vmax] font-jakarta font-bold text-zinc-800 dark:text-white " >
                            Rs. {formatNumberShort(totalOrders > 0 ? pmmCommission || 0 : 0)}
                        </span>
                        <span className="text-zinc-500 dark:text-slate-400 uppercase text-[1vmax] lg:text-[0.8vmax] font-semibold tracking-wider" >
                            PM's Commission
                        </span>
                    </div>
                    <div className="w-[30%] flex justify-end items-center">
                        <div className="w-[3.5vmax] h-[3.5vmax] bg-rose-50 dark:bg-rose-500/15 rounded-2xl grid place-items-center text-rose-600 dark:text-rose-300 text-[1.8vmax] ring-1 ring-rose-100 dark:ring-rose-400/20">
                            <i className="fa-solid fa-sack-dollar"></i>
                        </div>
                    </div>
                </div>

                {/* Card 3 */}
                <div className="w-[48%] lg:w-[31%] flex bg-white dark:bg-slate-950/70 p-[1.5vmax] shadow-sm hover:shadow-md transition-shadow duration-300 rounded-2xl border border-zinc-100 dark:border-amber-400/20 dark:shadow-[0_12px_32px_rgba(0,0,0,0.22)]">
                    <div className="w-[70%] flex justify-between flex-col gap-[0.5vmax]">
                        <span className="text-[2.5vmax] lg:text-[2vmax] font-jakarta font-bold text-zinc-800 dark:text-white " >
                            Rs. {formatNumberShort(totalOrders > 0 ? portalCommission || 0 : 0)}
                        </span>
                        <span className="text-zinc-500 dark:text-slate-400 uppercase text-[1vmax] lg:text-[0.8vmax] font-semibold tracking-wider" >
                            Portal Commission
                        </span>
                    </div>
                    <div className="w-[30%] flex justify-end items-center">
                        <div className="w-[3.5vmax] h-[3.5vmax] bg-amber-50 dark:bg-amber-500/15 rounded-2xl grid place-items-center text-amber-600 dark:text-amber-300 text-[1.8vmax] ring-1 ring-amber-100 dark:ring-amber-400/20">
                            <i className="fa-solid fa-building-columns"></i>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default TopBarValues
